<template>
  <fieldset>
    <legend class="screenreader">{{ placeholder }}</legend>
    <a :aria-expanded="isOpen ? 'true' : 'false'"
       :class="[{'active': isOpen}, 'filter-trigger', 'product-filter-toggler']"
       href="#"
       @click.prevent="toggleOpen()">
      <span class="screenreader" v-html="isOpen ? $t('generic.uitgeklapt') : $t('generic.ingeklapt')"/>
      {{ placeholder }}
    </a>
    <div :class="{'filter-wrapper': true, 'active': isOpen}" :aria-hidden="isOpen ? 'false' : 'true'">
      <div v-for="entity in entities" :key="entity.id" class="form-row">
        <div class="form-column">
          <input
            v-if="!multiple"
            :id="entity.id"
            :name="fieldName"
            :disabled="!entity.nrOfProductConfigurations > 0"
            :checked="entitySelectionDraft.find(candidate => candidate.id === entity.id)"
            type="radio"
            @change="entitySelectionDraft = [entity]"
          >
          <input
            v-if="multiple"
            :id="entity.id"
            :name="fieldName + '[' + entity.id + ']'"
            :disabled="!entity.nrOfProductConfigurations > 0"
            :checked="!!entitySelectionDraft.find(candidate => candidate.id === entity.id)"
            type="checkbox"
            @change="updateEntitySelectionDraft( entity, $event.target.checked)"
          >
          <label :class="{'disabled': !entity.nrOfProductConfigurations > 0}" :for="entity.id" v-text="entity.title"/>
        </div>
      </div>
      <button class="filter-trigger" type="button" @click.prevent="applyAndClose">
        {{ $t('productFilter.applyButtonText') }}
      </button>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default () { return this.$t('productFilter.defaultPlaceholder') }
    },
    entities: {
      type: Array,
      default: () => []
    },
    entitySelection: {
      type: Array,
      default: () => []
    },
    fieldName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpen: false,
      entitySelectionDraft: []
    }
  },
  watch: {
    entitySelection: function (val, oldVal) {
      // if the real selection is changed (externally), our draft selection should be reset.
      if (val !== oldVal) {
        this.resetEntitySelectionDraft()
      }
    }
  },
  methods: {
    toggleOpen () {
      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    },
    open () {
      this.resetEntitySelectionDraft()
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    },
    applyAndClose () {
      this.$emit('entitySelectionChanged', this.entitySelectionDraft)
      this.close()
    },
    updateEntitySelectionDraft (entity, include) {
      if (include) {
        this.entitySelectionDraft = [...this.entitySelectionDraft, entity]
      } else {
        this.entitySelectionDraft = this.entitySelectionDraft.filter(candidate => candidate.id !== entity.id)
      }
    },
    resetEntitySelectionDraft () {
      this.entitySelectionDraft = [...this.entitySelection]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductFilter.vue